import {
	requests
}from "../../../api/agent"

export default {
	create           : (params) => requests.post('/ReInfoOrg/create', params),
	update           : (params) => requests.post('/ReInfoOrg/update', params),
	delete           : (params) => requests.getWithParams('/ReInfoOrg/delete', params),
	restore          : (params) => requests.getWithParams('/ReInfoOrg/restore', params),
	getPaged         : (params) => requests.post('/ReInfoOrg/getPaged', params),
	getPagedAll      : (params) => requests.post('/ReInfoOrg/getPagedAll', params),
	getList          : (params) => requests.getWithParams('/ReInfoOrg/getList', params),
	getListByRoles   : (params) => requests.getWithParams('/ReInfoOrg/getListByRoles', params),
	getListByControl : (params) => requests.getWithParams('/ReInfoOrg/getListByControl', params),
	upload           : (params) => requests.post('/ReInfoOrg/upload', params),
	getExampleFile   : () => requests.getFile('/ReInfoOrg/getExampleFile'),
	getFile          : () => requests.getFile('/ReInfoOrg/getFile')
}